<template>
    <div class="bodyLogin">
        <el-image :src="logo" alt="Fiche partenaire" class="logoLogin"/>
        <el-container class="blockLogin">
            <el-header class="text-left blockHeaderLogin">

                Bienvenue
                <div class="text-center hr2Login"></div>
            </el-header>
            <el-main>
                <div class="blockTextLogin">Réinitialiser votre mot de passe</div>
                <el-form ref="motDePasse"
                         :model="motDePasse"
                         :rules="rules"
                         label-position="top"
                         @submit-valid="submit"
                         @submit-error="onError">
                    <el-row>
                        <el-col :sm="24" :xs="24" class="text-left">
                            <el-form-item prop="nouveauMotDePasse">
                                <h2 class="labelFormLogin">Choisissez un mot de passe</h2>
                                <el-input v-model="motDePasse.nouveauMotDePasse"
                                          placeholder="Entrez votre nouveau mot de passe" show-password></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" :xs="24" class="text-left">
                            <el-form-item prop="confirmerMotDePasse">
                                <h2 class="labelFormLogin">Confirmez votre mot de passe</h2>
                                <el-input v-model="motDePasse.confirmerMotDePasse"
                                          placeholder="Confirmez votre nouveau mot de passe" show-password></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-button class="buttonFonceLogin" native-type="submit" type="danger">
                        Ok
                    </el-button>
                </el-form>
            </el-main>
            <el-footer class="footerCardLogin">
                <div class="text-left blockTextLoginFooter"><strong>Retourner au formulaire de connexion ?</strong><br/>
                    <router-link :to="{ name: 'connexion'}"><u>Cliquez ici</u></router-link></div>
            </el-footer>
        </el-container>
        <div class="myFooterHeader">
            <br/>
            <div class="text-right"><a href="https://www.ubiflow.net" class="linkFooterLogin">Ubiflow.net</a></div>
        </div>
    </div>

</template>

<script>
    import elForm from "../components/forms/Form";
    import elFormItem from "../components/forms/FormItem";
    import logo from "../assets/logo2.png"
    import image from "../assets/logo.png";

    let authHeader = require('../_helpers/auth-header');


    export default {
        name: "ChangerMotDePasse",
        components: {elForm, elFormItem},
        data: () => ({
            motDePasse: {
                nouveauMotDePasse: '',
                confirmerMotDePasse: ''
            },
            error: null,
            image: image, logo,
            rules: {
                nouveauMotDePasse: [{required: true, message: 'Ce champ est obligatoire', trigger: ['blur', 'change']}],
                confirmerMotDePasse: [{
                    required: true,
                    message: 'Ce champ est obligatoire',
                    trigger: ['blur', 'change']
                }],
            },
        }),
        methods: {
            onError(error) {
                this.error = error;
            },
            async submit() {
                this.error = null;
                try {
                    let token = this.$route.params.token;
                    let result = await authHeader.updateUserPasswordFromToken(token, this.motDePasse.nouveauMotDePasse);
                    if (result.status !== 200) {
                        return false;
                    }
                    this.$router.push(
                        {
                            name:'connexion'
                        }
                    );
                } catch (err) {
                    this.error = err.message;
                } finally {
                    this.loading = false;
                }

            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    @import "../../public/css/stylesPageLogin.css";
</style>